import { Link } from 'react-router-dom';
import useScrollToTop from './useScrollToTop';

function About() {
  useScrollToTop();
  return (
    <div>
      <header className="about-header">
        <h1>About</h1>
      </header>
      
        <div className="about-body">
          <div className='aboutpage-text-container'>
            <div className='about-text'>
              <h2 className='about-text-left'>ABOUT</h2>
              <p className='about-text-right'>At KM Sound Strategies, we’re all about helping you share your unique sonic story! With 15 years of experience in professional audio engineering, we combine technical precision and artistry in every project, ensuring that your sound is clear, balanced, and truly impactful.

                We view collaboration as key at KM Sound Strategies. That’s why we’re happy to offer flexible revisions, making sure the final product fits perfectly with your vision and that the sound truly reflects your unique message. We believe that high-quality audio should be within everyone’s reach, and we strive to deliver industry-standard results at rates that won’t break the bank. At KM Sound Strategies, we’re not just an audio service; we’re your dedicated partner in bringing your creative voice to life!
                </p>
               
            </div>
          </div>
          <div className='aboutpage-text-container'>  
           
          <div className='bio-text'>
            <h2 className='bio-text-left'>BIO</h2>
            <p className='bio-text-right'>
        

                  Kane Mathis, the lead engineer at KMS, began his audio production journey in 1994 with an early version of Cakewalk requiring SMPTE code to sync MIDI and audio to a Tascam 4-track tape recorder. He was always fascinated by the challenges of bringing musical ideas into the world of documented audio. Over the years, this led to much experimentation, followed by a formal study of music production and audio engineering. Many of his early years were spent bringing his ideas to life. Still, around 2009, he began composing music for short films and instructional videos and eventually began scoring experimental music for modern dance and theater. Often mixing and mastering his own compositions, Kane became familiar with the needs of the wide variety of contexts that audio needed to translate to. This greatly expanded his engineering ability, and over subsequent years, he began extending this knowledge as a service to friends and acquaintances in need of affordable audio engineering services.  This was the heart of KMS Sound Strategies, using the love of audio to help artists on a budget realize their vision. As the market for music is more turbulent than ever Kane believes it has never been more critical to provide affordable access to audio services. 

              </p>
          </div>
          <Link to="/contact"><button>Request a Quote!</button></Link>
          </div>
         
         
        </div>
        
    </div>
  );
};

export default About;